import React from 'react';

const BadgeConfig = {
  // 공지사항
  전체: { bg: 'bg-primary/10', text: 'text-primary' },
  사업장: { bg: 'bg-blue-50', text: 'text-blue-600' },
  중요: { bg: 'bg-red-50', text: 'text-red-600' },
  NEW: { bg: 'bg-orange-500', text: 'text-white' },
  default: { bg: 'bg-slate-100', text: 'text-slate-600' },
  // 나의 결재 대기
  승인대기: { bg: 'bg-orange-100', text: 'text-orange-500' },
  승인요청: { bg: 'bg-orange-100', text: 'text-orange-500' },
  /** 교육일지(GetTraCustom02R1) Status */
  결재완료: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
  결재요청: { bg: 'bg-amber-50', text: 'text-amber-700' },
  결재대기: { bg: 'bg-slate-100', text: 'text-slate-600' },
  반려: { bg: 'bg-red-50', text: 'text-red-600' },
  대기: { bg: 'bg-slate-100', text: 'text-slate-600' },
  작업허가서: { bg: 'bg-blue-50', text: 'text-blue-600' },
  작업재개: { bg: 'bg-red-50', text: 'text-red-500' },
  교육일지: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
  작성완료: { bg: 'bg-emerald-50', text: 'text-emerald-700' },
};

export default function Badge({ type, label, className = '' }) {
  const config = BadgeConfig[type] || BadgeConfig.default;

  return (
    <div
      className={`inline-flex h-4.5 items-center justify-center rounded-xl px-2 py-1.5 text-[10px] font-bold whitespace-nowrap ${config.bg} ${config.text} ${className}`}
    >
      {label}
    </div>
  );
}
